





















import Vue from 'vue';
import Component from 'vue-class-component';
import TButton from '@/lib/form/button/Button.vue';
import Loader from '@/app/components/loaders/Loader.vue';
import WorkspaceUtils from '../utils/workspace-utils';
import VideoPlayer from '@/app/components/VideoPlayer.vue';
import publicClient from '@/app/clients/public-client';
import ActivityTracker from '@/app/player/models/activity-tracker';
import PlayerPermissionLinkSettings from '@/app/components/PlayerPermissionLinkSettings.vue';
import VideoNotAvailable from '@/app/components/VideoNotAvailable.vue';

@Component({
  name: 'embed-video',
  components: {
    TButton,
    Loader,
    VideoPlayer,
    PlayerPermissionLinkSettings,
    VideoNotAvailable
  }
})
export default class EmbedVideoComponent extends Vue {
  private loaded = false;
  private showVideoControls = false;
  private linkId!: string;
  private videoId!: string;
  private activityTracker: ActivityTracker | undefined = undefined;
  private video = {};

  mounted() {
    this.linkId = this.$route.params.linkId;
    publicClient
      .getShareableLinkInfo(this.linkId)
      .then(data => {
        this.videoId = data.videos_summary[0].id;
        return publicClient.getVideoInfo(this.linkId, this.videoId);
      })
      .then(data => {
        this.video = data;
        this.loaded = true;
        if (this.canTrackAnalytics(data)) {
          this.activityTracker = new ActivityTracker(
            this.videoId,
            this.linkId,
            'video_player',
            data.stepsInfo
          );
        }
      })
      .catch(e => {
        this.$error(e);
        this.loaded = true;
      });

    const workspace = WorkspaceUtils.parseWorkspaceName(
      window.location.hostname
    );
  }

  startTracker() {
    this.activityTracker && this.activityTracker.start();
  }

  canTrackAnalytics(data) {
    return (
      data.stepsInfo ||
      ['manual_upload', 'insta'].indexOf(data.templateType) > -1
    );
  }
}
